module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rf-field rf-range",
    class: _vm.finalComputedClass,
    attrs: {
      "data-min": _vm.computedMinLabel,
      "data-max": _vm.computedMaxLabel
    }
  }, [_vm._t("default", [(_vm.label) ? _c('label', {
    staticClass: "rf-label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]), _vm._v(" "), (_vm.showOutput) ? _c('output', {
    staticClass: "rf-output",
    class: {
      'invisible': !_vm.isDirty && !_vm.initialValue
    },
    style: (_vm.outputStyle),
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.value || '-'))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rf-input",
    style: (_vm.tickBackgroundSize)
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validation),
      expression: "validation"
    }],
    ref: "input",
    attrs: {
      "type": "range",
      "disabled": _vm.disabled || _vm.invalidRange,
      "id": _vm.name
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "change": _vm.onChange,
      "~mousedown": function($event) {
        _vm.onTouch($event)
      },
      "~touchstart": function($event) {
        _vm.onTouch($event)
      },
      "__r": function($event) {
        _vm.value = $event.target.value
      }
    }
  }, 'input', {
    name: _vm.name,
    min: _vm.min,
    max: _vm.max,
    step: _vm.step
  }, false)), _vm._v(" "), _c('div', {
    staticClass: "rf-slider-progress",
    style: (_vm.progressStyle)
  }), _vm._v(" "), (_vm.showInvalid) ? _c('rf-message', [_vm._v(_vm._s(_vm.errors.first(_vm.name)))]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-fast"
    }
  }, [(_vm.showInvalid) ? _c('icon', {
    key: "invalid",
    staticClass: "rf-icon rf-icon-invalid",
    attrs: {
      "name": "exclamation-triangle"
    }
  }) : _vm._e()], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eb346b7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frontend/components/RfRange.vue
// module id = 260
// module chunks = 0